module.exports = __webpack_public_path__ + "static/remonte-capilar-3.620370b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/remonte-capilar-3.jpg
// module id = 160
// module chunks = 48515692054781 141801459223525